import '../styles/coming-soon.css';
import React, { useEffect, useState } from 'react';
import { FaInstagram } from 'react-icons/fa';
import Logo from './Logo';

const ComingSoon: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Add a slight delay before showing the content with animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div className={`transition-opacity duration-1000 ease-in-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        <Logo />
        <h1 className="coming-soon-text text-center mt-8 text-5xl md:text-6xl lg:text-7xl">
          COMING SOON
        </h1>
        <div className="mt-6 flex justify-center">
          <a 
            href="https://www.instagram.com/streetvape__/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-black hover:text-gray-700 transition-colors duration-300"
          >
            <FaInstagram size={36} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;